// extracted by mini-css-extract-plugin
module.exports = {"footer":"GeneralStatisticsOneTable_footer__11aBF"};